import { createTheme } from '@mui/material/styles';

// Empty theme set up for future customisation. All frontend apps within this
// monorepo should be configured to use this theme.
const theme = createTheme({});

export default theme;
